import { useContext, useEffect, useState } from "react";
import {
  AppSpan,
  AppText,
  Button,
  CbpWraper,
  CustomContainer,
  FlexColumn,
  FlexRow,
  GridContainer,
  Icon,
  ScreenContainer,
} from "src/style";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import UserContext from "src/provider/state-manager/userProvider";
import { useNavigate } from "react-router-dom";
import CbpOnboardingPopUp from "src/component/Popup/Cbp/CbpOnboardingPopup";
import { IoArrowBackOutline } from "react-icons/io5";

export const CBPOnboarding = () => {
  const navigate = useNavigate();
  const {
    setInfoProperty,
    info: { institutionData },
  } = useContext(AppInfoContext);
  const {
    user: { onboardingInput },
    setUserProperty,
  } = useContext(UserContext);
  const [showOnboardingFlow, setShowOnboardingFlow] = useState(false);
  const [isTermsAndconditions, setIsTermsAndConditions] = useState(false);
  const [appLogo, setAppLogo] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    if (institutionData) setAppLogo(institutionData.logo);
  }, [institutionData?.logo]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const BulletList = ({ items }: { items: string[] }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      {items.map((item: any, index: any) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: "100%",
          }}
        >
          <span style={{ marginRight: "0.5rem", fontSize: "20px" }}>•</span>
          <AppText align="left" textSize="2">
            {item}
          </AppText>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <ScreenContainer
        leftPadding={isMobile ? "1" : "5"}
        padding={isMobile ? "1" : "0"}
        className="cbp-screen-container-bg"
      >
        <FlexRow>
          {(!isMobile || !showOnboardingFlow) && (
            <FlexRow>
              <FlexColumn padding="2" alignItems="flex-start">
                <CustomContainer width="20" height="8" bottomMargin="1">
                  {appLogo ? (
                    <Icon
                      src={appLogo}
                      className="app-logo-icon"
                      noResize
                      // onClick={() => navigate("/login")}
                    />
                  ) : null}
                </CustomContainer>
                <AppText
                  textSize="5"
                  fontWeight="800"
                  fontFamily="Gilmer-Bold"
                  bottomMargin="1"
                  align="left"
                >
                  Welcome to Cross-Border Payment
                </AppText>

                <AppText bottomMargin="1" align="left" textSize="2">
                  Your gateway to seamless international money transfers and
                  currency exchange. Send money across borders with confidence.
                </AppText>

                <AppText
                  fontWeight="800"
                  bottomMargin="0.5"
                  align="left"
                  textSize="3"
                >
                  Experience Modern Banking
                </AppText>

                <AppText align="left">
                  <BulletList
                    items={[
                      "Real-time currency exchange rates",
                      "Secure international transfers",
                      "Support for major global currencies",
                    ]}
                  />
                </AppText>

                {!showOnboardingFlow && (
                  <FlexColumn>
                    <Button
                      width="100"
                      sizeUnit="%"
                      topMargin="10"
                      height="5"
                      borderColor="#0D968F"
                      hoverBgColor="#fff"
                      hoverColor="#0D968F"
                      style={{ zIndex: 4 }}
                      titleSize="2"
                      onClick={() => {
                        setShowOnboardingFlow(!showOnboardingFlow);
                      }}
                    >
                      Continue
                    </Button>
                    <Button
                      width="100"
                      sizeUnit="%"
                      height="5"
                      topMargin="1"
                      bgColor="transparent"
                      borderColor="#D0D5DD"
                      hoverBgColor="#ffffff"
                      hoverColor="#0D968F"
                      titleSize="1.4"
                      color="#344054"
                      childHoverColor="#0D968F"
                      type="button"
                      onClick={() => {
                        setInfoProperty("cbp", false);
                        navigate(-1);
                      }}
                    >
                      <AppSpan color="#344054" rightMargin="1" textSize="1.6">
                        <IoArrowBackOutline />
                      </AppSpan>
                      Back
                    </Button>
                  </FlexColumn>
                )}
              </FlexColumn>

              {!isMobile && (
                <FlexColumn alignItems="flex-end" height="100" hUnit="vh">
                  {/* Main Image */}
                  <img
                    src={require("../../../assets/img/cbp-onboarding-img.png")}
                    alt="Description of the image"
                    width={450}
                    height={600}
                    style={{
                      position: "absolute",
                      bottom: 0,
                      zIndex: 2,
                    }}
                  />
                </FlexColumn>
              )}
            </FlexRow>
          )}

          <CbpWraper show={showOnboardingFlow}>
            <GridContainer
              overflow="auto"
              height="100"
              hUnit="vh"
              padding="3"
              width="50vw"
              bgColor="rgba(255, 255, 255, 0.95)"
              shadow="0px 4px 4px 0px #00000040"
              className="login-container"
              // style={{backgroundColor:'#000'}}
            >
              <CustomContainer>
                <CbpOnboardingPopUp
                  close={() => {
                    setShowOnboardingFlow(false);
                  }}
                />
              </CustomContainer>
            </GridContainer>
          </CbpWraper>
        </FlexRow>
      </ScreenContainer>
    </>
  );
};
